// extracted by mini-css-extract-plugin
export default {"main":"NumPad_main__wYGAE","num":"NumPad_num__9t2bO","extras":"NumPad_extras__WmNJA","toggle":"NumPad_toggle__PFs66","open":"NumPad_open__spSDp"};